/* ONSIDE — Build Your Bundle builder. Previews the ladder math only; the automatic
   discounts in Admin and the cart drawer are the source of truth once items are in the cart.
   Config + products are embedded by sections/byb-builder.liquid. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bb]');
  if (!root) return;
  var CFG = {}, PRODUCTS = [];
  try { CFG = JSON.parse(root.querySelector('[data-bb-config]').textContent); PRODUCTS = JSON.parse(root.querySelector('[data-bb-products]').textContent); } catch (e) { return; }

  function pairs(str, mapFn) { return String(str || '').split(',').map(function (s) { var kv = s.split(':'); return mapFn(parseInt(kv[0], 10), (kv[1] || '').trim()); }).filter(function (x) { return x && x.at > 0; }); }
  var LADDER = pairs(CFG.ladder, function (at, v) { return { at: at, pct: parseInt(v, 10) || 0 }; }).filter(function (t) { return t.pct > 0; }).sort(function (a, b) { return a.at - b.at; });
  var PERKS = pairs(CFG.perks, function (at, v) { return { at: at, text: v }; }).filter(function (p) { return p.text; });
  var ALLIN = (function () { var kv = String(CFG.allIn || '').split(':'); return { at: parseInt(kv[0], 10) || 0, pct: parseInt(kv[1], 10) || 0 }; })();
  var THRESHOLD = parseInt(CFG.threshold, 10) || 0;
  var HIDDEN = String(CFG.hidden || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
  var VIS = LADDER.filter(function (t) { return HIDDEN.indexOf(t.at) === -1; });
  var CREDIT = String(CFG.credit || '').trim();
  var CREDIT_MIN = parseInt(CFG.creditMin, 10) || 5;
  var TOTAL = PRODUCTS.length;
  var AVAIL = PRODUCTS.filter(function (p) { return p.available; });
  var skio = window.onsideSkioEnabled === true;
  var KEY = 'onside_byb_' + (CFG.collectionId || 'x');
  var state = { picked: {}, plan: skio ? String(CFG.defaultPlan || '') : '' };
  try { var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (saved && saved.picked) state = saved; } catch (e) {}
  if (!skio) state.plan = '';
  var TABS = CFG.tiersStyle === 'tabs', SIMPLE = CFG.barStyle === 'simple';
  if (state.target == null || (state.target === 'all' && !ALLIN.at)) state.target = ALLIN.at ? 'all' : (VIS.length ? String(VIS[VIS.length - 1].at) : 'all');
  function targetN() { return state.target === 'all' ? (ALLIN.at || AVAIL.length || TOTAL) : (parseInt(state.target, 10) || ALLIN.at || TOTAL); }
  // The goal follows the bundle up: pick past a size and the next size becomes the goal.
  function bumpTarget(n) { if (!TABS || n <= targetN()) return; var up = VIS.filter(function (x) { return x.at >= n; })[0]; state.target = up ? String(up.at) : 'all'; }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  function fmt(c) { return (window.Onside && Onside.formatMoney) ? Onside.formatMoney(c, window.onsideMoneyFormat) : '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function q(sel, el) { return (el || root).querySelector(sel); }
  function qa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function byId(id) { return PRODUCTS.filter(function (p) { return String(p.id) === String(id); })[0]; }
  function variant(p, vid) { return p.variants.filter(function (v) { return String(v.id) === String(vid); })[0]; }
  function defaultVariant(p) { return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]; }

  function lines() {
    var out = [];
    PRODUCTS.forEach(function (p) {
      var m = state.picked[p.id] || {};
      Object.keys(m).forEach(function (vid) { var n = m[vid] | 0, v = variant(p, vid); if (n > 0 && v) out.push({ p: p, v: v, qty: n }); });
    });
    return out;
  }
  function rateFor(n) { var r = 0; LADDER.forEach(function (t) { if (n >= t.at) r = t.pct; }); if (ALLIN.at && n >= ALLIN.at) r = ALLIN.pct; return r; }
  function nextTier(n) { var next = null; VIS.forEach(function (t) { if (!next && n < t.at) next = t; }); if (!next && ALLIN.at && n < ALLIN.at) next = { at: ALLIN.at, pct: ALLIN.pct, all: true }; return next; }
  function perkAt(at) { var prev = 0; VIS.forEach(function (t) { if (t.at < at && t.at > prev) prev = t.at; }); return PERKS.filter(function (p) { return p.at <= at && p.at > prev; }).map(function (p) { return p.text; }).join(' + '); }
  function totals() {
    var ls = lines(), n = 0, list = 0;
    ls.forEach(function (l) { n += l.qty; list += l.v.price * l.qty; });
    var rate = rateFor(n), price = ls.reduce(function (a, l) { var lt = l.v.price * l.qty; return a + lt - Math.floor(lt * rate / 100); }, 0);
    var subPct = skio && state.plan ? (state.plan === 'quarterly' ? (parseInt(CFG.subQuarterly, 10) || 0) : (parseInt(CFG.subMonthly, 10) || 0)) : 0;
    if (subPct) price = Math.round(price * (100 - subPct) / 100);
    var allIn = !!(ALLIN.at && n >= ALLIN.at);
    return { lines: ls, n: n, rate: rate, subPct: subPct, list: list, price: price, save: list - price, allIn: allIn, freeShip: n > 0 && price >= THRESHOLD, ready: LADDER.length ? n >= LADDER[0].at : n > 0, distinct: Object.keys(state.picked).length };
  }

  /* ---- mutations ---- */
  function setQty(pid, vid, n) {
    var m = state.picked[pid] || (state.picked[pid] = {});
    if (n <= 0) delete m[vid]; else m[vid] = n;
    if (!Object.keys(m).length) delete state.picked[pid];
    save(); render();
  }
  function add(pid, vid) {
    var p = byId(pid); if (!p) return;
    var v = vid ? variant(p, vid) : defaultVariant(p);
    if (!v || !v.available) return;
    var m = state.picked[pid] || {};
    setQty(pid, v.id, (m[v.id] | 0) + 1);
  }
  function removeProduct(pid) { delete state.picked[pid]; save(); render(); }
  function fillTo(n) {
    AVAIL.forEach(function (p) { if (totals().n >= n) return; if (!state.picked[p.id]) { var v = defaultVariant(p); if (v) { state.picked[p.id] = {}; state.picked[p.id][v.id] = 1; } } });
    save(); render();
  }
  function confetti(anchor) {
    if (!anchor || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var wrap = anchor.parentNode, colors = ['#E3AE79', '#1e1e1e', '#c8ac56', '#F6F5F1', '#8A5A2B'];
    for (var i = 0; i < 22; i++) {
      var s = document.createElement('span'); s.className = 'bb-confetti';
      var a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 90;
      s.style.setProperty('--dx', Math.cos(a) * d + 'px'); s.style.setProperty('--dy', Math.sin(a) * d - 40 + 'px');
      s.style.background = colors[i % colors.length]; s.style.animationDelay = (Math.random() * 80) + 'ms';
      wrap.appendChild(s); setTimeout(function (el) { el.remove(); }, 1100, s);
    }
  }
  function allPicked() { return AVAIL.length > 0 && AVAIL.every(function (p) { return !!state.picked[p.id]; }); }
  function goAllIn() { var was = allPicked(); fillTo(Infinity); if (!was && allPicked()) confetti(q('[data-bb-allin]')); }
  function clearAll() { state.picked = {}; save(); render(); }

  /* ---- render: product cards (server-rendered, state applied here) ---- */
  function renderCards(t) {
    qa('[data-bb-p]').forEach(function (card) {
      var pid = card.getAttribute('data-bb-p'), p = byId(pid); if (!p) return;
      var m = state.picked[pid] || {}, on = Object.keys(m).length > 0, oos = !p.available;
      card.classList.toggle('is-on', on);
      var tag = q('[data-bb-in]', card); if (tag) tag.hidden = !on;
      var scents = q('[data-bb-scents]', card); if (scents) scents.hidden = !(on && p.variants.length > 1);
      var dv = defaultVariant(p);
      var chosen = on ? variant(p, Object.keys(m)[0]) : dv;
      var img = q('[data-bb-img]', card); if (img && chosen && chosen.image && img.getAttribute('src') !== chosen.image) img.setAttribute('src', chosen.image);
      var price = q('[data-bb-price]', card), cmp = q('[data-bb-compare]', card);
      if (price && chosen) {
        var base = chosen.price, shown = (t.rate && on) ? Math.round(base * (100 - t.rate) / 100) : base;
        price.textContent = fmt(shown);
        price.classList.toggle('is-deal', !!(t.rate && on));
        if (cmp) { var c = (t.rate && on) ? base : (chosen.compare > base ? chosen.compare : 0); cmp.textContent = c ? fmt(c) : ''; cmp.hidden = !c; }
      }
      qa('[data-bb-chip]', card).forEach(function (chip) {
        var vid = chip.getAttribute('data-bb-chip'), n = m[vid] | 0;
        chip.classList.toggle('is-on', n > 0);
        var st = q('[data-bb-step]', chip); if (st) st.hidden = n < 1;
        var nn = q('[data-bb-n]', chip); if (nn) nn.textContent = n;
      });
      var btn = q('[data-bb-toggle]', card);
      if (btn) {
        btn.textContent = on ? (btn.getAttribute('data-remove') || 'Remove') : (oos ? (btn.getAttribute('data-oos') || 'Out of stock') : (btn.getAttribute('data-add') || 'Add +'));
        btn.disabled = oos && !on;
        btn.classList.toggle('is-on', on);
      }
    });
  }

  /* ---- render: panel ---- */
  function slotHtml(t, want) {
    var slotCount = want ? Math.max(want, t.n) : (t.allIn ? Math.max(t.n, 5) : Math.max(5, t.n));
    var units = [];
    t.lines.forEach(function (l) { for (var i = 0; i < l.qty; i++) units.push(l); });
    var html = '';
    for (var i = 0; i < slotCount; i++) {
      var l = units[i];
      if (!l) {
        var hint = '';
        VIS.concat(ALLIN.at ? [{ at: ALLIN.at, pct: ALLIN.pct }] : []).forEach(function (tier) { if (tier.at === i + 1) hint = tier.pct + '%'; });
        html += '<div class="bb-slot"><div class="bb-slot__frame bb-slot__frame--empty"><span>' + hint + '</span></div><div class="bb-slot__label"></div></div>';
      } else {
        html += '<div class="bb-slot"><div class="bb-slot__frame"><button type="button" class="bb-slot__x" data-bb-unpick="' + l.p.id + '" data-vid="' + l.v.id + '" aria-label="Remove ' + esc(l.p.title) + '">✕</button>' + (l.v.image ? '<img src="' + esc(l.v.image) + '" alt="">' : '') + '</div><div class="bb-slot__label">' + esc(l.p.short || l.p.title) + (l.v.title ? ' · ' + esc(l.v.short || l.v.title) : '') + '</div></div>';
      }
    }
    return html;
  }
  function giftsHtml(t) {
    // The offer as three icon bullets (discount, shipping, credit) plus any perks set in Theme settings; each ticks when unlocked.
    var rows = [], maxPct = 0;
    LADDER.forEach(function (r) { if (r.pct > maxPct) maxPct = r.pct; });
    if (ALLIN.pct > maxPct) maxPct = ALLIN.pct;
    if (LADDER.length) {
      var dsub = t.rate ? t.rate + '% off applied' : 'From ' + LADDER[0].at + ' products, automatically';
      rows.push({ label: 'Up to ' + maxPct + '% off', sub: dsub, on: t.rate > 0, icon: 'percent' });
    }
    rows.push({ label: 'Free shipping on orders ' + String(fmt(THRESHOLD)).replace(/\.00$/, '') + '+', sub: t.freeShip ? 'Unlocked' : String(fmt(Math.max(0, THRESHOLD - t.price))).replace(/\.00$/, '') + ' to go', on: t.freeShip, icon: 'truck' });
    if (CREDIT) {
      var cshort = CREDIT.split(' on ')[0];
      rows.push({ label: cshort + ' ' + (CFG.creditSuffix || 'on all bundles'), sub: t.n >= CREDIT_MIN ? 'Added to your order' : 'With ' + CREDIT_MIN + '+ products', on: t.n >= CREDIT_MIN || (skio && !!state.plan && t.n > 0), icon: 'money' });
    }
    PERKS.forEach(function (p) { rows.push({ label: p.text, sub: p.at + '+ products', on: t.n >= p.at, icon: 'star' }); });
    var unlocked = rows.filter(function (g) { return g.on; }).length;
    var html = '<ul class="bb-perks">' + rows.map(function (g) {
      var ic = CFG.icons && CFG.icons[g.icon] ? CFG.icons[g.icon] : '';
      return '<li class="bb-perk' + (g.on ? ' is-on' : '') + '"><span class="bb-perk__ic">' + ic + '</span><span class="bb-perk__t"><b>' + esc(g.label) + '</b><small>' + esc(g.sub) + '</small></span><span class="bb-perk__ok" aria-hidden="true">' + (g.on ? '✓' : '') + '</span></li>';
    }).join('') + '</ul>';
    return { html: html, note: unlocked + ' of ' + rows.length + ' unlocked' };
  }
  function renderPanel(t) {
    var panel = q('[data-bb-panel]'); if (!panel) return;
    q('[data-bb-count]', panel).textContent = t.n;
    q('[data-bb-slots]', panel).innerHTML = slotHtml(t);
    var next = nextTier(t.n), label = q('[data-bb-progress-label]', panel), nextEl = q('[data-bb-progress-next]', panel), fill = q('[data-bb-progress-fill]', panel);
    label.textContent = t.n + ' of ' + (ALLIN.at || AVAIL.length || TOTAL) + ' products';
    var msg;
    if (t.allIn) msg = 'All In · everything unlocked';
    else if (!next) msg = t.rate + '% off applied';
    else if (t.rate === 0) msg = 'Add ' + (next.at - t.n) + ' to save ' + next.pct + '%';
    else { var perk = perkAt(next.at); msg = (next.all ? 'Go All In for ' + next.pct + '%' : 'Add ' + (next.at - t.n) + ' more · ' + next.pct + '%' + (perk ? ' + ' + perk.toLowerCase() : '')); }
    nextEl.textContent = msg;
    var pct = t.allIn ? 100 : Math.min(97, (t.n / (ALLIN.at || TOTAL)) * 100);
    fill.style.width = pct + '%'; fill.classList.toggle('is-all', t.allIn);
    var g = giftsHtml(t);
    q('[data-bb-gifts]', panel).innerHTML = g.html;
    q('[data-bb-gift-note]', panel).textContent = g.note;
    q('[data-bb-total-label]', panel).textContent = t.rate ? (t.rate + '% bundle discount' + (t.subPct ? ' + extra ' + t.subPct + '% for subscribing' : '')) : (t.subPct ? 'Extra ' + t.subPct + '% for subscribing' : 'Bundle total');
    q('[data-bb-total]', panel).textContent = fmt(t.price);
    var listEl = q('[data-bb-list]', panel); listEl.textContent = t.rate ? fmt(t.list) : ''; listEl.hidden = !t.rate;
    var saveEl = q('[data-bb-save]', panel);
    saveEl.textContent = t.rate ? 'You save ' + fmt(t.save) + (PERKS.some(function (p) { return t.n >= p.at; }) ? ' + free extras' : '') : (t.n ? 'Add ' + ((LADDER[0] ? LADDER[0].at : 1) - t.n) + ' more to start saving' : '');
    var ship = q('[data-bb-ship]', panel);
    ship.textContent = t.n === 0 ? '' : t.freeShip ? 'Free shipping included' : (t.ready ? fmt(Math.max(0, THRESHOLD - t.price)) + ' from free shipping' : 'Free shipping on ' + fmt(THRESHOLD) + '+');
    var btn = q('[data-bb-add]', panel);
    btn.disabled = false; btn.classList.toggle('is-ready', t.ready);
    btn.textContent = t.ready ? (t.allIn ? 'Add All In to cart' : 'Add bundle to cart') : 'Add ' + Math.max(0, (LADDER[0] ? LADDER[0].at : 1) - t.n) + ' more to unlock';
    var sub = q('[data-bb-sub]', panel);
    if (sub) { sub.hidden = !skio; qa('[data-bb-plan]', sub).forEach(function (b) { var on = (b.getAttribute('data-bb-plan') || '') === (state.plan || ''); b.classList.toggle('is-on', on); if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
  }
  function renderBar(t) {
    var bar = q('[data-bb-bar]'); if (!bar) return;
    q('[data-bb-bar-plan]', bar).textContent = t.allIn ? 'All In · ' + ALLIN.pct + '% off' : t.rate ? t.n + ' products · ' + t.rate + '% off' : 'Build your bundle';
    q('[data-bb-bar-price]', bar).textContent = fmt(t.price);
    q('[data-bb-bar-count]', bar).textContent = t.n + ' picked';
    var b = q('[data-bb-bar-btn]', bar);
    b.textContent = t.ready ? (t.allIn ? 'Add All In' : 'Add bundle') : 'Build my bundle ↑';
    b.classList.toggle('is-ready', t.ready);
    if (SIMPLE) {
      var goal = Math.max(targetN(), t.n), nx = nextTier(t.n), first = LADDER[0];
      q('[data-bb-bar-plan]', bar).textContent = t.n + '/' + goal + ' selected';
      var note = q('[data-bb-bar-note]', bar);
      if (note) note.textContent = t.allIn ? 'All In · ' + ALLIN.pct + '% off' : t.rate ? t.rate + '% off' + (nx ? ' · ' + (nx.at - t.n) + ' more → ' + nx.pct + '%' : '') : (first ? 'Pick ' + first.at + ' → ' + first.pct + '% off' : '');
      var bf = q('[data-bb-bar-fill]', bar); if (bf) bf.style.width = Math.min(100, goal ? (t.n / goal) * 100 : 0) + '%';
      var bs = q('[data-bb-bar-slots]', bar);
      if (bs) {
        var units = []; t.lines.forEach(function (l) { for (var i = 0; i < l.qty; i++) units.push(l); });
        var cap = 5, extra = Math.max(0, Math.max(goal, units.length) - cap), html = '';
        for (var i = 0; i < cap; i++) {
          var u = units[i];
          if (i === cap - 1 && extra > 0) html += '<div class="bb-slot"><div class="bb-slot__frame bb-slot__frame--more' + (u ? ' is-filled' : '') + '">' + (u && u.v.image ? '<img src="' + esc(u.v.image) + '" alt="">' : '') + '<span>+' + (extra + (u ? 1 : 0)) + '</span></div></div>';
          else if (u) html += '<div class="bb-slot"><div class="bb-slot__frame"><button type="button" class="bb-slot__x" data-bb-unpick="' + u.p.id + '" data-vid="' + u.v.id + '" aria-label="Remove ' + esc(u.p.title) + '">✕</button>' + (u.v.image ? '<img src="' + esc(u.v.image) + '" alt="">' : '') + '</div></div>';
          else { var hint = ''; VIS.concat(ALLIN.at ? [{ at: ALLIN.at, pct: ALLIN.pct }] : []).forEach(function (tier) { if (tier.at === i + 1) hint = tier.pct + '%'; }); html += '<div class="bb-slot"><div class="bb-slot__frame bb-slot__frame--empty"><span>' + hint + '</span></div></div>'; }
        }
        bs.innerHTML = html;
      }
      b.textContent = t.ready ? (t.allIn ? 'Add All In to cart' : 'Add bundle to cart') : (t.n === 0 ? 'Pick your products' : 'Pick ' + Math.max(0, (first ? first.at : 1) - t.n) + ' more to unlock ' + (first ? first.pct : 0) + '%');
    }
  }
  function renderTiers(t) {
    qa('[data-bb-tier]').forEach(function (el) {
      var v = el.getAttribute('data-bb-tier'), active;
      if (TABS) { el.classList.toggle('is-on', String(v) === String(state.target)); el.setAttribute('aria-pressed', String(v) === String(state.target) ? 'true' : 'false'); return; }
      if (v === 'all') active = t.allIn;
      else { var at = parseInt(v, 10), next = VIS.filter(function (x) { return x.at > at; })[0]; active = !t.allIn && t.n >= at && (!next || t.n < next.at); }
      el.classList.toggle('is-on', active);
    });
    var allBtn = q('[data-bb-allin]');
    if (allBtn) {
      var allList = AVAIL.reduce(function (a, p) { var v = defaultVariant(p); return a + (v ? v.price : 0); }, 0);
      var pct = rateFor(AVAIL.length);
      var doneAll = allPicked();
      allBtn.classList.toggle('is-done', doneAll);
      var allLine = q('[data-bb-allin-line]') || allBtn;
      allLine.textContent = doneAll ? '✓ All ' + AVAIL.length + ' in · ' + (t.allIn ? ALLIN.pct : rateFor(t.n)) + '% locked in' : 'Tap to add all ' + AVAIL.length + ' · ' + fmt(Math.round(allList * (100 - pct) / 100)) + (pct ? ' · save ' + fmt(Math.round(allList * pct / 100)) : '');
      var panelEl = q('[data-bb-panel]'); if (panelEl) panelEl.classList.toggle('is-allin', doneAll);
    }
    var fillBtn = q('[data-bb-fill]');
    if (fillBtn) {
      var doneAllF = allPicked();
      var tn = targetN(), tp = rateFor(tn);
      if (state.target === 'all' && ALLIN.at) fillBtn.innerHTML = doneAllF ? '✓ All ' + AVAIL.length + ' in · ' + ALLIN.pct + '% locked in' : '<b>Add all ' + AVAIL.length + ' for me</b>';
      else fillBtn.innerHTML = t.n >= tn ? '✓ ' + t.n + ' picked · ' + t.rate + '% off' : '<b>Pick ' + tn + ' for me</b> · ' + tp + '% off · swap anything after';
      fillBtn.classList.toggle('is-done', state.target === 'all' && ALLIN.at ? doneAllF : t.n >= tn);
    }
  }
  function renderCompare() {
    var us = document.querySelector('[data-bb-cmp-us]'), them = document.querySelector('[data-bb-cmp-them]'), lab = document.querySelector('[data-bb-cmp-label]');
    if (!us || !them) return;
    var n = Math.min(5, AVAIL.length), list = 0;
    AVAIL.slice(0, n).forEach(function (p) { var v = defaultVariant(p); list += v ? v.price : 0; });
    var pct = rateFor(n);
    us.textContent = fmt(Math.round(list * (100 - pct) / 100)); them.textContent = fmt(list);
    if (lab) lab.textContent = n + ' products · ' + pct + '% off';
    var lab2 = document.querySelector('[data-bb-cmp-label-them]'); if (lab2) lab2.textContent = n + ' products · full price';
  }
  function renderPresets() {
    qa('[data-bb-preset-price]').forEach(function (el) {
      var k = el.getAttribute('data-bb-preset-price'), n = k === 'all' ? AVAIL.length : parseInt(k, 10), pct = k === 'all' ? (ALLIN.pct || rateFor(AVAIL.length)) : rateFor(n);
      var picks = AVAIL.slice(0, n), list = 0, price = 0;
      picks.forEach(function (p) { var v = defaultVariant(p); if (!v) return; list += v.price; price += v.price - Math.floor(v.price * pct / 100); });
      var card = el.closest('[data-bb-preset-card]'); if (card) card.hidden = picks.length < n;
      el.textContent = fmt(price); var ls = q('[data-bb-preset-list="' + k + '"]'); if (ls) ls.textContent = fmt(list);
    });
  }
  function render() { var t = totals(); bumpTarget(t.n); renderPresets(); renderCards(t); renderPanel(t); renderBar(t); renderTiers(t); }

  /* ---- add to cart ---- */
  function scrollToGrid() { var el = q('[data-bb-grid]'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  function setBusy(on, text) { qa('[data-bb-add],[data-bb-bar-btn]').forEach(function (b) { b.disabled = on; if (text) b.textContent = text; }); }
  function addToCart() {
    var t = totals();
    if (!t.ready) { scrollToGrid(); return; }
    var items = t.lines.map(function (l) {
      var it = { id: l.v.id, quantity: l.qty };
      if (l.v.backorder) it.properties = { _wait_and_save: 'true' };
      if (skio && state.plan && l.p.plans && l.p.plans[state.plan]) it.selling_plan = l.p.plans[state.plan];
      return it;
    });
    var protect = PERKS.filter(function (p) { return /protect/i.test(p.text); })[0];
    if (CFG.protectionVariant && protect && t.n >= protect.at) items.push({ id: parseInt(CFG.protectionVariant, 10), quantity: 1, properties: { _byb_protection: 'true' } });
    if (CFG.creditVariant && t.n >= CREDIT_MIN) items.push({ id: parseInt(CFG.creditVariant, 10), quantity: 1, properties: { _byb_credit: 'true' } });
    post(items, true);
  }
  function post(items, retry) {
    setBusy(true, 'Adding…');
    fetch(CFG.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok && !(d && d.status >= 400), d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.d && res.d.description) || 'Could not add';
          if (retry && items.some(function (i) { return i.selling_plan; })) { items.forEach(function (i) { delete i.selling_plan; }); return post(items, false); }
          var isMarker = function (i) { return i.properties && (i.properties._byb_protection || i.properties._byb_credit); };
          if (items.some(isMarker)) { return post(items.filter(function (i) { return !isMarker(i); }), false); }
          setBusy(false, msg.length > 40 ? msg.slice(0, 38) + '…' : msg);
          setTimeout(render, 2500);
          return;
        }
        setBusy(false, 'Added ✓');
        clearAll();
        if (typeof window.__onsideCartRefresh === 'function') window.__onsideCartRefresh(true); else window.location.href = CFG.cartUrl;
      })
      .catch(function () { setBusy(false, 'Network error'); setTimeout(render, 2500); });
  }

  /* ---- events ---- */
  root.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-bb-toggle]'))) { var card = el.closest('[data-bb-p]'), pid = card.getAttribute('data-bb-p'); if (state.picked[pid]) removeProduct(pid); else add(pid); return; }
    if ((el = e.target.closest('[data-bb-inc]'))) { var chip = el.closest('[data-bb-chip]'), c1 = chip.closest('[data-bb-p]'); var m = state.picked[c1.getAttribute('data-bb-p')] || {}; setQty(c1.getAttribute('data-bb-p'), chip.getAttribute('data-bb-chip'), (m[chip.getAttribute('data-bb-chip')] | 0) + 1); return; }
    if ((el = e.target.closest('[data-bb-dec]'))) { var chip2 = el.closest('[data-bb-chip]'), c2 = chip2.closest('[data-bb-p]'); var m2 = state.picked[c2.getAttribute('data-bb-p')] || {}; setQty(c2.getAttribute('data-bb-p'), chip2.getAttribute('data-bb-chip'), (m2[chip2.getAttribute('data-bb-chip')] | 0) - 1); return; }
    if ((el = e.target.closest('[data-bb-pick]'))) { var chip3 = el.closest('[data-bb-chip]'), c3 = chip3.closest('[data-bb-p]'); if (!chip3.classList.contains('is-on')) add(c3.getAttribute('data-bb-p'), chip3.getAttribute('data-bb-chip')); return; }
    if ((el = e.target.closest('[data-bb-unpick]'))) { var m3 = state.picked[el.getAttribute('data-bb-unpick')] || {}; setQty(el.getAttribute('data-bb-unpick'), el.getAttribute('data-vid'), (m3[el.getAttribute('data-vid')] | 0) - 1); return; }
    if ((el = e.target.closest('[data-bb-preset]'))) { var pk = el.getAttribute('data-bb-preset'); state.picked = {}; state.target = pk; if (pk === 'all') goAllIn(); else fillTo(parseInt(pk, 10)); var sh = q('[data-bb-sheet]'); if (sh && window.innerWidth < 1080) sheetOpen(true); else { var pn = q('[data-bb-panel]'); pn && pn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } return; }
    if (e.target.closest('[data-bb-fill]')) { if (state.target === 'all') goAllIn(); else fillTo(targetN()); return; }
    if ((el = e.target.closest('[data-bb-tier]'))) { var v = el.getAttribute('data-bb-tier'); if (TABS) { state.target = v; save(); render(); } else if (v === 'all') goAllIn(); else fillTo(parseInt(v, 10)); return; }
    if (e.target.closest('[data-bb-allin]')) { goAllIn(); return; }
    if (e.target.closest('[data-bb-clear]')) { clearAll(); return; }
    if (e.target.closest('[data-bb-add]') || e.target.closest('[data-bb-bar-btn]')) { addToCart(); return; }
    if ((el = e.target.closest('[data-bb-plan]'))) { state.plan = el.getAttribute('data-bb-plan') || ''; save(); render(); return; }
  });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-bb-scroll]')) { e.preventDefault(); scrollToGrid(); } });

  /* ---- mobile bottom sheet: the panel slides up over the bar ---- */
  var sheet = q('[data-bb-sheet]'), backdrop = q('[data-bb-sheet-close]'), barEl = q('[data-bb-bar]');
  function barH() { return barEl ? barEl.offsetHeight : 0; }
  function setBarVar() { document.documentElement.style.setProperty('--bb-bar-h', barH() + 'px'); }
  function sheetOpen(open) {
    if (!sheet) return;
    setBarVar();
    sheet.classList.toggle('is-open', open);
    document.body.classList.toggle('bb-sheet-open', open);
    if (backdrop) backdrop.hidden = !open;
    qa('[data-bb-sheet-toggle]').forEach(function (b) { if (b.setAttribute) b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  window.addEventListener('resize', setBarVar); setBarVar();
  var lastSwipe = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bb-sheet-toggle]')) { if (Date.now() - lastSwipe < 600) return; sheetOpen(!sheet.classList.contains('is-open')); return; }
    if (e.target.closest('[data-bb-sheet-close]')) { sheetOpen(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && sheet.classList.contains('is-open')) sheetOpen(false); });
  (function () {
    var y0 = null, x0 = null, fromPanel = false, panelEl = q('[data-bb-panel]');
    function start(e) {
      var inBar = e.target.closest('[data-bb-bar]'), inPanel = e.target.closest('[data-bb-panel]');
      if (!inBar && !inPanel) { y0 = null; return; }
      fromPanel = !!inPanel;
      y0 = e.touches ? e.touches[0].clientY : e.clientY; x0 = e.touches ? e.touches[0].clientX : e.clientX;
    }
    function end(e) {
      if (y0 == null) return;
      var y1 = e.changedTouches ? e.changedTouches[0].clientY : e.clientY, x1 = e.changedTouches ? e.changedTouches[0].clientX : e.clientX, dy = y1 - y0, dx = Math.abs(x1 - x0); y0 = null;
      if (dx > Math.abs(dy)) return;
      var open = sheet && sheet.classList.contains('is-open');
      if (!open && dy < -40 && !fromPanel) { lastSwipe = Date.now(); sheetOpen(true); }
      else if (open && dy > 50 && (!fromPanel || (panelEl && panelEl.scrollTop <= 0))) { lastSwipe = Date.now(); sheetOpen(false); }
    }
    document.addEventListener('touchstart', start, { passive: true }); document.addEventListener('touchend', end, { passive: true });
  })();
  document.addEventListener('onside:cart', function () { if (sheet && sheet.classList.contains('is-open') && window.innerWidth < 1080) sheetOpen(false); });

  // Deep links from product pages: ?pick=<handle> pre-picks that product, ?allin=1 fills the whole line.
  try {
    var sp = new URLSearchParams(window.location.search), pickH = sp.get('pick'), allIn = sp.get('allin') === '1';
    if (pickH || allIn) {
      String(pickH || '').split(',').forEach(function (h) {
        var pp = PRODUCTS.filter(function (p) { return p.handle === h.trim(); })[0];
        if (pp && pp.available && !state.picked[pp.id]) { var pv = defaultVariant(pp); if (pv) { state.picked[pp.id] = {}; state.picked[pp.id][pv.id] = 1; } }
      });
      if (allIn) fillTo(Infinity);
      save();
      sp.delete('pick'); sp.delete('allin');
      var qs = sp.toString();
      if (window.history && history.replaceState) history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      window.__bbDeepLinked = true;
    }
  } catch (e) {}
  render();
  renderCompare();
  if (window.__bbDeepLinked) { var panelEl = q('[data-bb-panel]'); if (panelEl && window.innerWidth < 1024) setTimeout(function () { var g = q('[data-bb-grid]'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250); }
  window.OnsideBundleBuilder = { add: add, goAllIn: goAllIn, clear: clearAll, totals: totals };
})();
